<template>
  <swipe-modal v-if="computedBottomSheet" v-model="isModal" contents-height="70vh" border-top-radius="16px">
    <div class="container pt-3">
      <div class="row">
        <h4 v-if="computedBottomSheet.title">{{computedBottomSheet.title}}</h4>
        <hr>
      </div>
      <template v-if="computedBottomSheet.content">
        <keep-alive>
          <component :is="computedBottomSheet.content.render"
                     :class="computedBottomSheet.content.customClass ?? ''"
                     v-on="computedBottomSheet.content.events ?? []"
                     v-bind="computedBottomSheet.content.content ?? {}"></component>
        </keep-alive>
      </template>
    </div>
  </swipe-modal>
</template>

<script setup lang="ts">
import {IBottomSheet} from "@/interfaces/components/general/IBottomSheet";
import {computed, ref, watch} from "vue";

const isModal = ref(false)
const props = defineProps<{
  bottomSheet: IBottomSheet,
}>()

const computedBottomSheet = computed(() => props.bottomSheet);

watch(computedBottomSheet, (value) => {
  isModal.value = value.show
}, {deep: true})

</script>

<style scoped>

</style>